module.exports = __webpack_public_path__ + "static/media/hind-demi.10a0bfda.woff2";